var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwilio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 014-4h36a4 4 0 014 4v36a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
    fill: "#CF272D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twilio_svg__clip0_17025_444831)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.987 30.841a8.828 8.828 0 110-17.656 8.828 8.828 0 010 17.656zm0-20.815C15.367 10.026 10 15.393 10 22.013S15.367 34 21.987 34s11.987-5.367 11.987-11.987-5.367-11.987-11.987-11.987z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.48 19.028a2.492 2.492 0 114.984 0 2.492 2.492 0 01-4.984 0zm0 5.97a2.493 2.493 0 114.985 0 2.493 2.493 0 01-4.985 0zm-5.97 0a2.493 2.493 0 114.984 0 2.493 2.493 0 01-4.985 0zm0-5.97a2.492 2.492 0 114.984 0 2.492 2.492 0 01-4.985 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twilio_svg__clip0_17025_444831"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 10)",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgTwilio;